import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('apuracao', 'tabloide');
const gestaoApuracao = getBasePath('apuracao', 'gestao');

const apuracaoTabloideActions = {
  competencias: { method: 'GET', url: `${basePath}/competencias` },
  configuracao: { method: 'GET', url: `${basePath}/configuracao-apuracao` },
  pagina: { method: 'GET', url: `${basePath}/pagina?tamanhoPagina={size}&numeroPagina={page}` },
  salvar: { method: 'PUT', url: `${basePath}/salvar` },
  resgatar: { method: 'PUT', url: `${basePath}/{idApuracao}/resgatar` },
  finalizar: { method: 'PUT', url: `${gestaoApuracao}/{idApuracao}/finalizar` },
  desdobramentoMeta: { method: 'GET', url: `${basePath}/desdobramento-meta` },
  ajustar: { method: 'PUT', url: `${basePath}/{idApuracao}/ajustar` },
  registraUsuario: { method: 'PUT', url: `${gestaoApuracao}/{idApuracao}/registra/usuario` },
  salvarContratoCliente: { method: 'PUT', url: `${basePath}/atualizar/{id}/contrato_cliente/{codContratoCliente}` },
  enviarFilaApuracao: { method: 'POST', url: `${gestaoApuracao}/enviar-fila-apuracao` },
};

export default resource => resource(`${basePath}`, {}, apuracaoTabloideActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/apuracao-tabloide.js